<div #container
     class="container bg2 page-keyword2">

  <app-header [keyHistory]="HistoryKeySearch"
              placeholder="동영상을 검색 합니다."
              canGoHistory="true"
              (goHistory)="onGoHistory()"
              (search)="SearchVideo($event)"></app-header>

  <app-left-menu></app-left-menu>


  <section class="video-screen-list">

    <div class="inner wrap">

      <div class="screen-list-group">

        <div *ngIf="ListCategory.length === 0 && !IsLoading"
             class="empty-box">
          <div class="img-box">
            <img src="assets/img/img_menu_tiger.svg">
          </div>
          <div class="keyword-no-result-box">
            영상이 없습니다.
          </div>

        </div>
        <div class="reload-icon" *ngIf="IsLoading">
          <img #reload src="assets/img/loading_icon.gif">
        </div>
        <div class="screen-box screen{{ findVideoData(cat.category).cssIdx }} swiper-{{ idx }}"
             *ngFor="let cat of ListCategory; let idx=index">

          <div class="tit-box">
            <span>{{ findVideoData(cat.category).name }}</span>
            <span *ngIf="getRouterLink(cat) && cat.videoCollect.length > 2"
                  class="more-btn"
                  [routerLink]="getRouterLink(cat)"
                  [queryParams]="getQueryParams(cat)">더 보기</span></div>
          <div class="list-box">

            <a class="swiper-button-prev"
               [class.hide]="cat.videoCollect.length <= 2"></a>
            <a class="swiper-button-next"
               [class.hide]="cat.videoCollect.length <= 2"></a>

            <swiper [config]="config"
                    [navigation]="GetSwiperNavigationTxt(idx)">
              <ng-template swiperSlide *ngFor="let video of cat.videoCollect">
                <app-video-box [video]="video"
                               [sendingBookmark]="sendingBookmark"
                               (toggleBookmark)="ToggleBookmark($event)"></app-video-box>
              </ng-template>
            </swiper>

          </div>

        </div>

      </div>

    </div>
  </section>


  <app-footer [on]="FooterOn.MOVIE_COLLECT"></app-footer>

</div>

<app-common-popups></app-common-popups>
